<template lang="pug">
div.section-setting
	div.section-title
		b.title {{ title }}
	div.section-body
		slot
</template>

<script>
	export default {
		name: "GlobalSectionSetting",
		props: {
			title:{
				type: String
			}
		}
	}
</script>

<style scoped lang="scss">
	.section-title {
		font-size: 0.8em;
		margin-bottom: 10px;
	}
    .section-setting {
        + .section-setting {
			margin-top: 20px;
        }

		.section-body {
			border-bottom: 1px solid #e0e0e0;
			padding: 15px 15px;
			margin-left: -15px;
			margin-right: -15px;
		}
    }
</style>
